module.exports = __webpack_public_path__ + "img/withdraw-money.55997995.svg";